import { Component, inject, OnInit } from '@angular/core';
import { DecisionMakerService, IDecisionMaker } from './decision-maker.service';
import { CommonModule } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { FormsModule } from '@angular/forms';
import { CustomersService } from '../../../services/customers/customers.service';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { Router } from '@angular/router';
import { Buffer } from 'buffer';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'decision-maker',
  standalone: true,
  imports: [CommonModule, NzTableModule, NzCheckboxModule, FormsModule, NzSkeletonModule, NzIconModule, NzButtonModule, NzToolTipModule ],
  templateUrl: './decision-maker.component.html',
  styleUrl: './decision-maker.component.scss'
})
export class DecisionMakerComponent implements OnInit {
  private dmService = inject(DecisionMakerService);
  private customersService = inject(CustomersService);
  private router = inject(Router);
  dmList?: IDecisionMaker[]
  tenants?: any[]
  isLoading = true;
  isCalculating = true;
  dmPercent?: number;
  fronteggCount?: number;

  ngOnInit(): void {
    this.customersService.getCustomers().subscribe(res => {
      this.tenants = res.filter((t: any) => t.exclude_statistics === false);
      this.calculateDmPercent();
    });
    this.dmService.getDecisionMakers().subscribe(res => {
      this.dmList = res;
      this.isLoading = false;
      this.calculateDmPercent();
    });
  }

  private calculateDmPercent(): void {
    if (!this.dmList || !this.tenants) {
      return;
    }
    this.fronteggCount = this.dmList.filter(dm => dm.is_frontegg_user).length;
    this.dmPercent = this.tenants.length ? Math.ceil((this.fronteggCount / this.dmList.length) * 100) : 0;
    this.isCalculating = false;
  }

  openTenant(id: string) {
    const encodedId = Buffer.from(id).toString('base64');
    this.router.navigateByUrl(`tenants/${encodedId}`);
  }

}
